//Alternative to Math.trunc()
export function truncate(value) {
	value = +value;

	if(!isFinite(value)) {
		return value;
	}

	return value - (value % 1) || (value < 0 ? -0 : value === 0 ? value : 0);
}

export function repeat(value, count) {
	"use strict";
	if(value == null) {
		throw new TypeError("can't convert " + value + " to object");
	}
	let str = "" + value;
	count = +count;
	if(count != count) {
		count = 0;
	}
	if(count < 0) {
		throw new RangeError("repeat count must be non-negative");
	}
	if(count == Infinity) {
		throw new RangeError("repeat count must be less than infinity");
	}
	count = Math.floor(count);
	if(str.length == 0 || count == 0) {
		return "";
	}

	if(str.length * count >= 1 << 28) {
		throw new RangeError(
			"repeat count must not overflow maximum string size"
		);
	}
	const maxCount = str.length * count;
	count = Math.floor(Math.log(count) / Math.log(2));
	while(count) {
		str += str;
		count--;
	}
	str += str.substring(0, maxCount - str.length);
	return str;
}

if(typeof String.prototype.trimLeft !== "function") {
	String.prototype.trimLeft = function() {
		return this.replace(/^\s+/, "");
	};
}

if(typeof String.prototype.trimRight !== "function") {
	String.prototype.trimRight = function() {
		return this.replace(/\s+$/, "");
	};
}
